import { formatColorName } from '@util/common.js';
import { deepSignal } from 'deepsignal';
import { CHARITY } from '@util/const.js';
import CustomizeSection from '@components/overlays/shared/customize-section.jsx';
import Description from '@components/overlays/shared/description.jsx';
import LinkSetup from '@components/overlays/shared/link-setup.jsx';
import ScaledOverlayWrapper from '@components/overlays/wrapper/scaled-overlay-wrapper.jsx';
import ColorPicker from '@components/pickers/color-picker/color.picker.jsx';
import CharitySection from '@components/shared/charity-section.jsx';
import { MinProgressBar } from '@playlive/overlay-core/progress-bars/min';
import { toColor } from '@playlive/overlay-core/colors';
import HorizontalCustomizeWrapper from '@components/overlays/wrapper/horizonal-customize-wrapper.jsx';
import useCommon from '@hooks/useCommon.js';
import useDemoProgressBarData from '@hooks/useDemoProgressBarData.js';

const config = deepSignal({
  charityType: CHARITY.TILTIFY,
  bgColor: 'default-red',
});

export default function MinProgressBarPage() {
  const { setConfigState, overlayURL, overlayInfo } = useCommon({ config });

  const { demoMilestones } = useDemoProgressBarData(config);

  function filterColors(color) {
    return !color.includes('grey') && !color.includes('black');
  }

  return (
    <div className="w-full overflow-x-hidden">
      <div className="flex flex-col xl:flex-row overflow-x-hidden">
        <div className="example_overlay select-none w-full">
          <ScaledOverlayWrapper allowScaling={false} innerClassName="h-[250px]">
            <MinProgressBar
              className="shadow-2xl"
              milestones={demoMilestones}
              goalAmount={1000}
              backgroundColor={toColor(config.bgColor)}
              currentAmount={750}
            />
          </ScaledOverlayWrapper>
        </div>

        <HorizontalCustomizeWrapper>
          <CharitySection
            onChange={setConfigState}
            charityType={config.charityType}
          />

          <CustomizeSection title="Colors">
            <span className="label-text mb-2">
              Progress bar: <b>{formatColorName(config.bgColor)}</b>
            </span>

            <ColorPicker
              filterFunction={filterColors}
              currentColor={config.bgColor}
              fieldName="bgColor"
              onChange={setConfigState}
            />
          </CustomizeSection>
        </HorizontalCustomizeWrapper>
      </div>

      <Description>
        <p className="pb-4">
          Utilize our dynamic Minimal overlay to enhance your Tiltify
          fundraising campaign. This overlay fits any layout and tracks your
          fundraising total.
        </p>
      </Description>

      <LinkSetup
        constrainWidth={false}
        charityType={config.charityType}
        obsDimensions={overlayInfo.obsDimensions}
        overlayName={overlayInfo.name}
        overlayURL={overlayURL}
      />
    </div>
  );
}
